/**
 * Returns an decremented number.
 *
 * @param value - The number to decrement.
 *
 * @returns The decremented number.
 */
export var decrement = function decrement(value) {
  return value - 1;
};